export default __webpack_public_path__ + "static/media/FREE_NEXT_ICONA.b180de5f.svg";